export const MOBILE_BREAKPOINT = 600
export const TABLET_BREAKPOINT = 900
export const SMALL_DESKTOP_BREAKPOINT = 1200
export const LARGE_DESKTOP_BREAKPOINT = 1600
